// extracted by mini-css-extract-plugin
export default {"NavigationFooter":"navigation-footer_NavigationFooter__jagb8","NavigationFooter__logo":"navigation-footer_NavigationFooter__logo__5J6i8"};